<section [ngStyle]="sectionStyles">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }
  <div class="file-list" [ngStyle]="fileListStyles">
    <!-- No file - read only -->
    @if (!selectedFiles?.length && isReadOnly) {
      <div [ngStyle]="uploadedStyles" class="selected-file">
        <div class="fileitem filename italic"> No file </div>
      </div>
    }
    <!-- List of selected files -->
    @if (selectedFiles?.length || isReadOnly) {
      <blaze-scroller>
        <div
          cdkDropList
          (cdkDropListDropped)="reorderFiles($event)"
          [cdkDropListDisabled]="isInEditor || !isSortingEnabled"
          class="selected-files"
        >
          @for (selectedFile of selectedFiles; track selectedFile) {
            <div cdkDrag cdkDragLockAxis="y" [ngStyle]="uploadedStyles" class="selected-file">
              @if (isSortingEnabled) {
                <mat-icon cdkDragHandle class="drag-handle" svgIcon="icon_drag_16" />
              }
              <!-- Inert in the editor: this spans the row, where a click has to select the element. -->
              <a
                [blazeFileDownloadLink]="selectedFile"
                [isSecure]="isFileSecure"
                [isDisabled]="isInEditor"
                class="fileitem filelink"
              >
                <img class="filetype" [src]="getFileTypeIcon(selectedFile)" alt="" loading="lazy" />
                <span class="filename">{{ selectedFile.filename }}</span>
              </a>
              <!-- Stays live in the editor — the only way to open a file while building. -->
              <a
                [blazeFileDownloadLink]="selectedFile"
                [isSecure]="isFileSecure"
                [ngStyle]="uploadedResetStyles"
                [attr.aria-label]="'Open or download ' + selectedFile.filename"
                class="download"
              >
                <mat-icon svgIcon="icon_download_16" />
              </a>
              @if (!isReadOnly) {
                <button
                  (click)="resetUpload(selectedFile)"
                  [ngStyle]="uploadedResetStyles"
                  class="reset"
                >
                  <mat-icon svgIcon="close" />
                </button>
              }
            </div>
          }
        </div>
      </blaze-scroller>
    }

    <!-- Upload button -->
    @if (isUploadPossible) {
      @if (isDragAndDropEnabled) {
        <div
          class="upload-hint"
          (dragover)="allowDrop($event)"
          (drop)="drop($event)"
          [ngStyle]="dragAndDropStyles"
        >
          <div class="hint">
            Drop file to upload, or&nbsp;<a
              blazeClickable
              [ngStyle]="dragAndDropActionStyles"
              (click)="fileInput.click()"
              >browse</a
            >
          </div>
        </div>
      } @else {
        <button
          (click)="emitClick()"
          [class.validation-error]="hasValidationError"
          [ngStyle]="uploadStyles"
          class="upload"
        >
          <div class="shade"></div>
          @if (buttonIcon) {
            <mat-icon [style.--icon-size]="props?.style?.upload?.iconSize" [svgIcon]="buttonIcon" />
          }
          @if (buttonLabel) {
            <span>{{ buttonLabel }}</span>
          }
        </button>
      }
    }
  </div>
</section>

<input
  #fileInput
  class="hidden"
  type="file"
  [multiple]="isMultiple"
  [accept]="acceptedExtensions"
  [attr.capture]="capture"
  (change)="fileSelected($event.target)"
/>

@if (hasValidationError) {
  <div class="validation" [ngStyle]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}
